import * as React from "react"

import Footer from "../footer/Footer"
import LandingFooter from "../landing-footer/LandingFooter"
import LandingNav from "../landing-nav/LandingNav"
import CookiePopup from "../cookiePopup/CookiePopup"
import Navbar from "../navbar/Navbar"
import { Helmet } from "react-helmet"
import useIsInEditor from "../../../hooks/useIsInEditor"

const Layout = ({ children, navigation, locale, location, isLanding = false, content }) => {
  const isInEditor = useIsInEditor()
  return (
    <>
      {isLanding ? <LandingNav navigation={navigation} lang={locale} location={location} content={content}/> : <Navbar navigation={navigation} lang={locale} location={location}/>}
      <div>
        <main>{children}</main>
      </div>
      <CookiePopup locale={locale} />
      {isLanding ? <LandingFooter navigation={navigation} lang={locale}/> : <Footer navigation={navigation} lang={locale}/>}
    </>
  )
}

export default Layout
